//social
import telegram from '../assets/img/social/telegram.png';
import discord from '../assets/img/social/discord.png';
import youtube from '../assets/img/social/youtube.png';
import twitter from '../assets/img/social/twitter.png';
import reddit from '../assets/img/social/twitter.png';
import tiktok from '../assets/img/social/twitter.png';
import instagram from '../assets/img/social/instagram.png';
import x from '../assets/icon/shapes/x.png';
//end social

//system
import support from '../assets/icon/support.png';
import faq from '../assets/icon/faq.png';
import share from '../assets/icon/share.png';
import dog from '../assets/img/dog.png';
import promo_share from '../assets/icon/promo_share.png';
import setting from '../assets/icon/setting.png';
import checked from '../assets/icon/checked.png';
import gift from '../assets/icon/Gift.png';
import octo from '../assets/logo/logo.png';
import inc from '../assets/icon/in.png';
import wallet from '../assets/icon/wallet.png';
import friend from '../assets/icon/friend.png';
import dep from '../assets/icon/balance/deopsit.png';
import withdraw from '../assets/icon/balance/withdraw.png';
import history from '../assets/icon/balance/history.png';
import def from '../assets/img/def.png';
import cup from '../assets/icon/cup.png';
import img from '../assets/icon/picture_placeholder.png';
import magic from '../assets/icon/magic.png'
import clear from '../assets/icon/clear.png'

//end system

//shapes
import crown from '../assets/icon/shapes/crown.png';
import diamond from '../assets/icon/shapes/diamond.png';
import plus from '../assets/icon/shapes/plus.png';
import Star from '../assets/icon/shapes/thin_star.png';
import Star_big from '../assets/icon/shapes/star.png';
import Rectangle from '../assets/icon/shapes/square.png';
import polygonShape from '../assets/icon/shapes/polygon.png';
import tgStarShape from '../assets/icon/blockchains/tg_star.png';
//end shapes

//shapes-outlined
import ou_polygon from '../assets/icon/out_shapes/polygone_out.png';
import ou_rectangle from '../assets/icon/out_shapes/rectangle_out.png';
import out_star from '../assets/icon/out_shapes/star_out.png';
import ou_plus from '../assets/icon/out_shapes/plus_out.png';
import ou_crown from '../assets/icon/out_shapes/crown_out.png';
import out_small_star from '../assets/icon/out_shapes/thin_star_out.png';
import ou_diamond from '../assets/icon/out_shapes/diamond_out.png';
import link from '../assets/icon/link.svg';
import copy from '../assets/icon/out_shapes/copy.svg';
//end shapes-outlined

//chains
import solana from '../assets/icon/blockchains/solana.png';
import BNB from '../assets/icon/blockchains/BNB.png';
import ETH from '../assets/icon/blockchains/ETH.png';
import TON from '../assets/icon/blockchains/TON.png';
import USDC from '../assets/icon/blockchains/USDC.png';
import USDT from '../assets/icon/blockchains/USDT.png';
import base from '../assets/icon/blockchains/base.svg';
import optimism from '../assets/icon/blockchains/optimism.svg';
import avalanche from '../assets/icon/blockchains/avalanche.svg';
import arbitrum from '../assets/icon/blockchains/arbitrum.svg';
import sui from '../assets/icon/blockchains/sui.svg';
import polygonChain from '../assets/icon/blockchains/polygon.svg';
import tgStarChain from '../assets/icon/blockchains/tg_star.png';
//end chains
//tasks
import youtube_bell from '../assets/img/tasks/youtube_bell.png'
import youtube_video from '../assets/img/tasks/youtube_video.png'
import youtube_sub from '../assets/img/tasks/youtube_sub.png'
import custom from '../assets/icon/custom.png'
import pen from '../assets/icon/pen.png'
//end tasks

const icons = [
    //social
    {name: "telegram", icon: telegram},
    {name: "instagram", icon: instagram},
    {name: "reddit", icon: reddit},
    {name: "discord", icon: discord},
    {name: "youtube", icon: youtube},
    {name: "tiktok", icon: tiktok},
    {name: "twitter", icon: twitter},
    {name: "support", icon: support},
    //end social

    //system
    {name: "faq", icon: faq},
    {name: "share", icon: share},
    {name: "promo_share", icon: promo_share},
    {name: "dog", icon: dog},
    {name: "setting", icon: setting},
    {name: "checked", icon: checked},
    {name: "gift", icon: gift},
    {name: "octo", icon: octo},
    {name: "inc", icon: inc},
    {name: "wallet", icon: wallet},
    {name: "friend", icon: friend},
    {name: "def", icon: def},
    {name: "dep", icon: dep},
    {name: "withdraw", icon: withdraw},
    {name: "history", icon: history},
    {name: "cup", icon: cup},
    {name: "img", icon: img},
    {name:'magic',icon:magic},
    {name:'clear',icon:clear},

    //end system

    //shapes
    {name: "crown", icon: crown},
    {name: "plus", icon: plus},
    {name: "x", icon: x},
    {name: "diamond", icon: diamond},
    {name: "star", icon: Star},
    {name: "star_big", icon: Star_big},
    {name: "rectangle", icon: Rectangle},
    {name: "polygon", icon: polygonShape},
    {name: "tg_star", icon: tgStarShape},
    //end shapes

    //shapes-outlined
    {name: "ou_polygon", icon: ou_polygon},
    {name: "ou_rectangle", icon: ou_rectangle},
    {name: "out_star", icon: out_star},
    {name: "ou_plus", icon: ou_plus},
    {name: "ou_crown", icon: ou_crown},
    {name: "out_small_star", icon: out_small_star},
    {name: "ou_diamond", icon: ou_diamond},
    {name: "link", icon: link},
    {name:"copy", icon: copy},
    //end shapes-outlined

    //chains
    {name: "solana", icon: solana},
    {name: "BNB", icon: BNB},
    {name: "TON", icon: TON},
    {name: "USDC", icon: USDC},
    {name: "USDT", icon: USDT},
    {name: "ETH", icon: ETH},
    {name: "base", icon: base},
    {name: "optimism", icon: optimism},
    {name: "avalanche", icon: avalanche},
    {name: "arbitrum", icon: arbitrum},
    {name: "sui", icon: sui},
    {name: "polygon_chain", icon: polygonChain},
    {name: "tg_star_chain", icon: tgStarChain},
    {name: "hardhat", icon: ETH},
    //end chains
    //tasks
    {name:"youtube bell",icon:youtube_bell},
    {name:"youtube sub",icon:youtube_sub},
    {name:"youtube video",icon:youtube_video},
    {name:"custom",icon:custom},
    {name:"pen",icon:pen},
    //end tasks
]

const getIcon = (name) => {
    const icon = icons.find((item) => item.name === name);
    return icon ? icon.icon : null; // Возвращаем иконку или null, если иконка не найдена
};

export default getIcon;
